import { useLocation } from "react-router-dom";
import { IconProps } from "../../types/component.types";

export function BasicUtilityIcon(props: IconProps) {

    const location = useLocation();
    const { pathname } = location;
    return (
        <svg className="shrink-0 h-6 w-6" viewBox="0 0 24 24">
            <circle
                className={`fill-current ${pathname.includes('utility') ? 'text-indigo-300' : 'text-slate-400'}`}
                cx="18.5"
                cy="5.5"
                r="4.5"
            />
            <circle
                className={`fill-current ${pathname.includes('utility') ? 'text-indigo-500' : 'text-slate-600'}`}
                cx="5.5"
                cy="5.5"
                r="4.5"
            />
            <circle
                className={`fill-current ${pathname.includes('utility') ? 'text-indigo-500' : 'text-slate-600'}`}
                cx="18.5"
                cy="18.5"
                r="4.5"
            />
            <circle
                className={`fill-current ${pathname.includes('utility') ? 'text-indigo-300' : 'text-slate-400'}`}
                cx="5.5"
                cy="18.5"
                r="4.5"
            />
        </svg>
    )
}